import GATSBY_COMPILED_MDX from "/opt/build/repo/src/support/timepage/actions-integration/actions-in-timepage.md";
import {graphql} from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import Docs from '../components/Docs';
const DocsPage = ({data, pageContext: {slug, category, section}, children}) => {
  const {excerpt, frontmatter: {title, description, cover, toc}, tableOfContents} = data.mdx;
  const image = cover ? cover.childImageSharp.resize : null;
  return React.createElement(Docs, {
    slug: slug,
    excerpt: excerpt,
    title: title,
    description: description,
    image: image,
    category: category,
    section: section,
    tableOfContents: toc === false ? null : tableOfContents
  }, children);
};
DocsPage.propTypes = {
  data: PropTypes.shape({
    mdx: PropTypes.shape({
      tableOfContents: PropTypes.object,
      frontmatter: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        cover: PropTypes.object,
        toc: PropTypes.bool,
        childImageSharp: PropTypes.object
      })
    })
  }).isRequired,
  pageContext: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    category: PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string
    })
  }).isRequired
};
DocsPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(DocsPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query Docs($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      excerpt
      tableOfContents
      frontmatter {
        title
        description
        toc
        cover {
          childImageSharp {
            resize(width: 800, quality: 90, toFormat: PNG) {
              src
              width
              height
            }
          }
        }
      }
    }
  }
`;
